import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import InputBase from './input';

function FormikInput(props) {
  const { fieldConfig, FieldHelperTextProps, onBlur, ...others } = props;
  const [field, meta] = useField(fieldConfig);
  return (
    <>
      <InputBase
        fullWidth
        error={meta.touched && !!meta.error}
        {...field}
        {...others}
        onBlur={(e) => {
          // The event variable must not empty and should be a standard Event object, otherwise an error will occur
          if (e && field.onBlur) {
            field.onBlur(e);
          }
          onBlur(e);
        }}
      />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </>
  );
}
FormikInput.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  onBlur: PropTypes.func,
  // all other props will be applied to InputBase component
};
FormikInput.defaultProps = {
  FieldHelperTextProps: undefined,
  onBlur: () => {},
};
export default FormikInput;
